import React from 'react';
import { Helmet } from 'react-helmet';

export const JsonLd = ({ data }) => (
  <Helmet>
    <script type="application/ld+json">{JSON.stringify(data)}</script>
  </Helmet>
);
